import { availableLocales } from '@app/constants';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { Seo } from '@redbubble/next-seo';
import nextSeoMetaTags from '@redbubble/next-seo/meta';
import getConfig from 'next/config';

export const messages = defineMessages({
  description: {
    defaultMessage:
      'Over 700,000 creatives worldwide making things like shirts, stickers, phone cases, and pillows weirdly meaningful. Find your thing or open your own shop.',
  },
  title: {
    defaultMessage: 'Awesome products designed by independent artists',
  },
});

const SEOTags = () => {
  const intl = useIntl();
  const config = getConfig();
  const { baseUrl: canonicalUrl } = config.publicRuntimeConfig.app;
  const languageAlternates = Object.values(availableLocales).map(
    ({ name, urlSegment }) => {
      return {
        hrefLang: name,
        href: `${canonicalUrl}${urlSegment}`,
      };
    }
  );
  const titleTemplate = '%s | Redbubble';

  return (
    <Seo
      title={`${intl.formatMessage(messages.title)}`}
      titleTemplate={titleTemplate}
      description={intl.formatMessage(messages.description)}
      canonical={canonicalUrl}
      languageAlternates={languageAlternates}
      additionalMetaTags={nextSeoMetaTags}
    />
  );
};

export { SEOTags };
